import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/browser-client";
import { getAccessStatus } from "@/lib/access.functions";
import { AppShell } from "@/components/AppShell";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) throw redirect({ to: "/" });
    // Only an explicit "not allowed" answer blocks entry. A transient failure
    // (network, cold start) must not bounce an authenticated user to ?denied=1 —
    // every server function still enforces auth and role checks on its own.
    const access = await getAccessStatus().catch((err) => {
      console.error("[access] status check failed, allowing through:", err);
      return { allowed: true };
    });
    if (!access.allowed) {
      throw redirect({ to: "/", search: { denied: "1" } });
    }
    return { user: data.user };
  },

  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
